import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { WalletsCreateRequest } from 'types/wallets'

export const createWalletSchema = (t: TFunction<'translation', undefined>) => {
  return yup.object<Partial<Record<keyof WalletsCreateRequest, yup.AnySchema>>>({
    currency: yup.string().required(),
    description: yup.string().required(t('walletNameRequired')).max(40, t('walletNameLengthError')),
    profileId: yup.string().optional(),
  })
}
